import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

import gcLogo from "../../../../../assets/images/logos/glasschain-mra-logo.png";
import gcPrinterGnomeLogo from "../../../.././/../assets/images/logos/gc-printerGnome-small.png"

import changeLog from "../../../../../changelog";


export default class ModalAboutDialog extends Component {

  render() {

    var browserString = <span>Browser: {this.props.deviceInfo.browser.browserName} Version: {this.props.deviceInfo.browser.fullBrowserVersion}&nbsp;&nbsp;{(this.props.deviceInfo.browser.browserSubTypes.length > 0) ? this.props.deviceInfo.browser.browserSubTypes.join('-') : ""}</span>
    var appVer = <span>Version: {(this.props.appInfo.version.msaApp) ? this.props.appInfo.version.msaApp : ""}</span>
    var appBuild = <span>Build: {(this.props.appInfo.version.build) ? this.props.appInfo.version.build : ""}</span>
    var coreVer = <span>MSA API Version: {(this.props.appInfo.version.msaCore) ? this.props.appInfo.version.msaCore.appVersion : ""}</span>
    var coreLastBuild = <span>MSA API Last Build: {(this.props.appInfo.version.msaCore) ? this.props.appInfo.version.msaCore.lastBuild.toString() : ""}</span>
    var qaVer = <span>QA API Version: {(this.props.appInfo.version.qaCore) ? this.props.appInfo.version.qaCore.appVersion : ""}</span>
    var qaLastBuild = <span>MSA API Last Build: {(this.props.appInfo.version.qaCore) ? this.props.appInfo.version.qaCore.lastBuild.toString() : ""}</span>
    var deviceType = "Unknown";
    if ((this.props.deviceInfo.device.isDesktop)) { deviceType = "Desktop Browser" }
    else if (this.props.deviceInfo.device.isTablet) { deviceType = "Tablet Browser" }
    else if (this.props.deviceInfo.device.isMobile) { deviceType = "Mobile Browser" }
    var location = ((this.props.userSession.locationInfo) && (this.props.userSession.locationInfo.warehouse) && (this.props.userSession.locationInfo.warehouse.id)) ? 
        this.props.userSession.locationInfo.warehouse.id + "-" + this.props.userSession.locationInfo.warehouse.name 
        : "Unknown";





    var auxInfo = ((this.props.userSession.locationInfo) && (this.props.userSession.locationInfo.auxInfo)) ?
      this.props.userSession.locationInfo.auxInfo:
      {qaLocationId: "Unknown", tagPrinter: "", tagPrinterFormat: "", isGnomePrinter: false};
    var qaLocation = auxInfo.qaLocationId;
    var region = (auxInfo.regionId) ? auxInfo.regionName + " (" + auxInfo.regionId + ")" : "Unknown";
    //var tagPrinter =  auxInfo.tagPrinter + "-" + auxInfo.tagPrinterAddress + " (" + auxInfo.tagPrinterAccessType + ")";
    //var tagPrinterFormat = auxInfo.tagFormat;
    //var printerGnomeIndicator = (auxInfo.isGnomePrinter) ? <img src={gcPrinterGnomeLogo} alt="printerGnome"/> : <span/> 
 

    var currentLocation = (this.props.userSession && this.props.userSession.locationInfo && this.props.userSession.locationInfo.warehouse) ? this.props.userSession.locationInfo.warehouse.name: "";
    var sublocations = [];
    if ((currentLocation !== "") && (currentLocation !== "all"))
    {
      sublocations = this.props.userSession.locationInfo.auxInfo.sublocations.map((sub) =>
        <div>
          {(sub.isGnomePrinter) ? <img src={gcPrinterGnomeLogo} alt="printerGnome"/> : <span/>}
          <div>{sub.sublocationName} - {sub.tagPrinterAccessType} ({sub.tagPrinterAddress}) - ({sub.tagFormat})</div>
        </div>
      );
    }









    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onAboutDialogCloseRequest}
      >
        <Modal.Header closeButton>
          <Modal.Title>About glasschain mra</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col>
              <img
                src={gcLogo}
                alt="glasschain logo"
              />
            </Col>
            <Col>
              <div style={{ color: "gray", fontSize: "8pt" }}>
                <div center="true">Glasschain Observations</div>
                <div center="true">Powered by Glassbit</div>
                <div center="true">{appVer}</div>
                <div center="true">{appBuild} </div>
                <div center="true">{coreVer} </div>
                <div center="true">{coreLastBuild} </div>
                <div center="true">{qaVer} </div>
                <div center="true">{qaLastBuild} </div>
                <hr/>

                <div center="true">Glasschain Id: {(this.props.userSession.gcid) ? this.props.userSession.gcid : ""}</div>
                <div center="true">Warehouse: {location}</div>
                <div center="true">Region: {region}</div>
                <div center="true">QA Location: {qaLocation}</div>
    
                <div center="true">Device Type: {deviceType}</div>
                <div center="true">{browserString} </div>

                <hr/>
                <div>Printers:</div>
                {sublocations.map(sub => {
                  return sub;
                })}          
              </div>

              <hr/>
              <div style={{ color: "gray", fontSize: "10pt" }}>Change Log</div>
              <div>
                {changeLog.map((version) => 
                {
                  return <div style={{ color: "gray", fontSize: "8pt" }} key={version.version}>Version {version.version}
                    {version.issues.map(issue =>
                      {
                        return <div style={{ color: "gray", fontSize: "8pt" }} key={issue.id}>{issue.id}-{issue.description}</div>
                      })}
                      <br/>
                  </div>
                })}

              </div>


            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.props.onAboutDialogCloseRequest}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
